/**
 * Tags catalog API client.
 *
 * Mirrors `backend/src/hub/routes/tags.py`. Returns the union of
 * all tags currently in use across workflows, ingress sources and
 * canonical schemas, with per-resource counts. Used by ``TagsField``
 * and ``TagFilter`` for autocomplete.
 */
import { api } from "./api";

export interface TagUsage {
  tag: string;
  workflows: number;
  ingress_sources: number;
  canonicals: number;
}

export interface TagsResponse {
  tags: TagUsage[];
}

export const tagsApi = {
  list: () => api.get<TagsResponse>("/tags"),
};
